import BaseApi from "./BaseApi";

/**
 * @property {UserServiceApi} userService
 * @property {SystemServiceApi} systemService
 * @property {StoreServiceApi} storeService
 * @property {PromotionServiceApi} promotionService
 * @property {GuildMemberServiceApi} guildMemberService
 * @property {GuildMotdServiceApi} guildMotdService
 * @property {GuildServiceApi} guildService
 * @property {InventoryServiceApi} inventoryService
 * @property {BugReportServiceApi} bugReportService
 * @property {PromoCodeServiceApi} promoCodeService
 * @property {MinigamesServiceApi} minigamesService
 * @property {LotteryServiceApi} lotteryService
 * @property {TermsServiceApi} termsService
 * @property {PwShardsServiceApi} pwShardsService
 * @property {MailerServiceApi} mailerService
 * @property {PerfectChanceServiceApi} perfectChanceService
 *
 * @type {BaseApi}
 */
const api = new BaseApi();
export default api;
